import React from 'react';
import {useNavigate} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllConfigs, switchSmaConfig, deleteSmaConfig } from '../../store/slices/sma.slice';
import { Table, Space, Typography } from 'antd';

import Button from '@mui/material/Button';
import EventCard from "../../components/EventCard/EventCard";
import Avatars from "../../components/Graphics/Avatars";
import {useTickerSearchIndex} from "../../modules/Search/useTickerSearchIndex";
import {iconMapping} from '../../configs/AppsConfig'
const { Title } = Typography;



const SmaCard = ({ key, config, handleOpenConfig, handleDeleteConfig }) => {
    const { id, name, etfs } = config;
    const { tickers } = useTickerSearchIndex(etfs.map(etf => etf.symbol));

    // Extract ETF information for display
    const etfNames = etfs.map(etf => etf.symbol);

    // Calculate total portfolio allocation
    const totalAllocation = etfs.reduce((sum, etf) => sum + etf.weight, 0);

    return (
        <EventCard
            title={name || `Untitled...`}
            text={''}
            content={<Avatars urls={tickers.map(x=>x.logo)} alt={etfNames} size={38}/>}
            bottomLeft={<div>{etfs.length} ETFs - {(totalAllocation*100).toFixed(1)}% Allocated</div>}
            bottomRight={
                <Button
                    size={'small'}
                    variant={'outlined'}
                    onClick={() => handleOpenConfig(id)}
                >
                    Open SMA
                </Button>
            }
            color="transparent"
            srcUrl={iconMapping.smalab}
        />
    );
};


const SmaDrafts = ({ onSubmit }) => {
  const dispatch = useDispatch();
  const configs = useSelector(selectAllConfigs);
  const navigate = useNavigate();

  // Function to switch between SMA configs
    const handleConfigClick = async (configId) => {
        await dispatch(switchSmaConfig({ smaConfigId: configId }));
        // First update the redux state
        onSubmit(); // Call the callback to update parent view state
        // Then navigate
        navigate('/builders/sma');
    };


  // Function to delete a config
  const handleDeleteConfig = (configId) => {
    dispatch(deleteSmaConfig({ smaConfigId: configId }));
  };

  const nonEmptyConfigs = configs?.filter?.(config=>config?.etfs?.length>0||config?.name);

  return (
    <Space direction={'vertical'} style={{width: '100%'}}>
        {Array.isArray(nonEmptyConfigs) && nonEmptyConfigs.map((config, index) => (
            <SmaCard
                key={config.id}
                config={config}
                handleDeleteConfig={handleDeleteConfig}
                handleOpenConfig={handleConfigClick}
            />
        ))}
    </Space>
  );
};

export default SmaDrafts;
